import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { QueryParams } from '@/constants/QueryParam';
import { routeMap } from '@/routes/routeMap';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList';
import { constructURL } from '@/utils/url';

type Payload = { creditDebt?: number; debtConsolidationDebt?: number; loanDebt?: number };
type Props = ModalProps<Payload>;

function RemainingDebtInfo({ payload: { creditDebt, debtConsolidationDebt, loanDebt } }: Props) {
  const { t } = useTranslation(['Modal', 'Common']);
  const hasCreditDebt = !!creditDebt;
  const hasDebtConsolidationDebt = !!debtConsolidationDebt;
  const hasLoanDebt = !!loanDebt;

  let linkToDeposit = '';

  if (hasCreditDebt) {
    linkToDeposit = constructURL(routeMap.credit.deposit.root, {
      relative: true,
      queryParams: {
        [QueryParams.SELECT_MAX_AMOUNT]: 'true',
      },
    });
  } else if (hasDebtConsolidationDebt) {
    linkToDeposit = constructURL(routeMap.debtConsolidation.deposit, {
      relative: true,
      queryParams: {
        [QueryParams.SELECT_MAX_AMOUNT]: 'true',
      },
    });
  } else if (hasLoanDebt) {
    linkToDeposit = constructURL(routeMap.loan.deposit, {
      relative: true,
      queryParams: {
        [QueryParams.SELECT_MAX_AMOUNT]: 'true',
      },
    });
  }

  return (
    <Modal title={t('RemainingDebtInfo.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('RemainingDebtInfo.info')}</p>
        <p>{t('RemainingDebtInfo.infoSecond')}</p>

        <DataList>
          {!!hasCreditDebt && (
            <DataListItem>
              <DataListLabel>{t('RemainingDebtInfo.creditProduct')}</DataListLabel>
              <DataListValue>{t('Common:money', { amount: creditDebt })}</DataListValue>
            </DataListItem>
          )}
          {!!hasDebtConsolidationDebt && (
            <DataListItem>
              <DataListLabel>{t('RemainingDebtInfo.debtConsolidationProduct')}</DataListLabel>
              <DataListValue>{t('Common:money', { amount: debtConsolidationDebt })}</DataListValue>
            </DataListItem>
          )}
          {!!hasLoanDebt && (
            <DataListItem>
              <DataListLabel>{t('RemainingDebtInfo.loanProduct')}</DataListLabel>
              <DataListValue>{t('Common:money', { amount: loanDebt })}</DataListValue>
            </DataListItem>
          )}
        </DataList>
      </div>
      <ModalActions>
        <LinkButton to={linkToDeposit}>{t('RemainingDebtInfo.action')}</LinkButton>
      </ModalActions>
    </Modal>
  );
}

export default RemainingDebtInfo;
